var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('BarChartGenerator',{attrs:{"chart-options":_vm.chartOptions,"chart-data":{ labels: _vm.labels, datasets: _vm.datasets },"chart-id":_vm.chartId,"dataset-id-key":_vm.datasetIdKey,"css-classes":_vm.cssClasses,"styles":_vm.styles,"width":_vm.width,"height":_vm.height}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }